export default __webpack_public_path__ + "static/media/Goshoppi2.ce69ff3d.png";